export class TableObject {

    userProfile;
    id;
    ownerId;
    holdEndDate;
    price;
    status;
    tableNo;
    anonymousUserId;
    currentAnynomusUserId;

    constructor() {
        this.currentAnynomusUserId = localStorage.getItem('AnonymousUserId');
        this.userProfile = JSON.parse(localStorage.getItem('eahsUserProfile')) ?? '';
    }

    static fromRaw(raw) {
        const self = new TableObject();
        Object.assign(self, raw);
        return self;
    }

    state() {
        const statusCodeToState = {
            1: 'available',
            2: 'booked',
            3: 'NA',
            4: !!this.userProfile?.id ? (this.ownerId === this.userProfile?.id ? 'selected' : 'hold') : this.anonymousUserId === this.currentAnynomusUserId ? 'selected' : 'hold'
        };

        const state = statusCodeToState[this.status] ?? 'NA';
        return state;
    }
}
